import React from 'react'
import wbLogo from '../../img/world-bank-group.png'
import atlasLogo from '../../img/atlas-logo.png'
import { slide as Menu } from 'react-burger-menu'
import { chapters } from '../../data/hamburger.json'

const Header = () => {
  const slug = window.location.href
    .split('/')
    .slice(-2)
    .shift()

  return (
    <>
      <Menu right width={330}>
        <a className='menu-item' href='..'>
          Home
        </a>
        {chapters.map(d => {
          return (
            <a
              key={'menu' + d.url}
              className={'menu-item'}
              href={'../' + d.url}
              dangerouslySetInnerHTML={{
                __html:
                  slug === d.url
                    ? `<b>${d.goal}. ${d.subhead}</b>`
                    : `<b>${d.goal}.</b> ${d.subhead}`
              }}
            ></a>
          )
        })}
        <a className='menu-item' href='../targets'>
          Targets
        </a>
      </Menu>
      <header>
        <a href='https://www.worldbank.org/'>
          <img src={wbLogo} className='wbLogo' alt='World Bank logo' />
        </a>
        <a href='http://datatopics.worldbank.org/sdgatlas/'>
          <img
            src={atlasLogo}
            className='atlasLogo'
            alt='SDG Atlas 2020 logo'
          />
        </a>
      </header>
    </>
  )
}

export default Header
